import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { entryExitDashboardKeys } from "./query";
import { PostModel } from "common/models/BaseModel";
import {
  IEntryExitDashboardFilter,
  ICurrentlyInsideGridFilter,
  IEntryExitDashboardLogGridFilter,
} from "./types";

export function useGetEntryExitSummary(filter: IEntryExitDashboardFilter) {
  return useQuery(entryExitDashboardKeys.summary(filter));
}

export function useGetEntryExitCharts(filter: IEntryExitDashboardFilter) {
  return useQuery(entryExitDashboardKeys.charts(filter));
}

export function useGetCurrentlyInside(
  postModel: PostModel<ICurrentlyInsideGridFilter>
) {
  return useQuery({
    ...entryExitDashboardKeys.currentlyInside(postModel),
    placeholderData: keepPreviousData,
  });
}

export function useGetEntryExitLogs(
  postModel: PostModel<IEntryExitDashboardLogGridFilter>
) {
  return useQuery({
    ...entryExitDashboardKeys.logs(postModel),
    placeholderData: keepPreviousData,
  });
}
